import styled from 'styled-components';

import { media } from '~src/styles/media-templates';

export const PageFormContainer = styled.form`
  padding-top: 70px;
  margin-bottom: 85px;
  display: flex;
  ${media.tablet`
    flex-direction: column;
  `}
`;

export const FormWrapper = styled.div`
  min-height: 560px;
`;

export const ButtonFooter = styled.div`
  position: fixed;
  bottom: 0;
  left: 60px;
  width: calc(100% - 75px);
  border-top: 2px solid ${({ theme }) => theme.black.a1};
  background-color: ${({ theme }) => theme.background};
  display: flex;
  column-gap: 15px;
  row-gap: 15px;
  flex-direction: row;
  padding: 15px;
  z-index: 3;
  ${media.phone`
    flex-direction: column;
    width: 100%;
    left: 0;
  `}
`;

export const ButtonSpacing = styled.div`
  flex-grow: 1;
  ${media.phone`
    display: none;
  `}
`;

export const ButtonWrapper = styled.div`
  flex-grow: 0;
`;
